<template>
  <div class="form-group" :class="{ '-error': error }">
    <div class="input">
      <input id="location" type="text" class="pac-target-input" :class="{ '-filled': value }" :placeholder="placeholder" autocomplete="off" v-model="value" @focusin="handleFocusin" @focusout="handleFocusout" ref="input">
      <div class="input-background">
        <label for="location">{{ label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
/* global google */

export default {
  name: 'GoogleAutocomplete',
  data () {
    return {
      autocomplete: null,
      value: '',
      focus: false
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectFirstOnKeydown () {
      const self = this.$refs.input
      /* Store original event listener */
      const addEventListener = self.addEventListener

      self.addEventListener = (type, listener) => {
        let modifiedListener = listener
        if (type === 'keydown') {
          /* Store existing listener function */
          modifiedListener = event => {
            /* Simulate a 'down arrow' keypress if suggestions available */
            const suggestions = document.getElementsByClassName('pac-item').length > 0
            if ((event.which === 9 || event.which === 13) && suggestions) {
              event.preventDefault()
              const suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0
              if (!suggestionSelected) {
                const e = new CustomEvent(JSON.parse(JSON.stringify(event)))
                e.which = 40
                e.keyCode = 40
                listener.apply(self, [e])
              }
            }
            listener.apply(self, [event])
          }
        }
        addEventListener.apply(
          self,
          [
            type,
            modifiedListener
          ]
        )
      }
    },
    handleFocusin () {
      this.focus = true
    },
    handleFocusout () {
      this.focus = false
      if (this.location !== this.value) {
        this.value = ''
        this.$emit('placeChanged', { location: '', latitude: '', longitude: '', country: '' })
      }
    }
  },
  mounted () {
    const self = this
    self.value = self.location
    const southwest = {
      lat: 36.3027639,
      lng: -12.3010810
    }
    const northeast = {
      lat: 70.9546922,
      lng: 32.6989190
    }
    const strictBounds = new google.maps.LatLngBounds(southwest, northeast)
    const options = {
      fields: [
        'geometry',
        'formatted_address',
        'address_components'
      ],
      bounds: strictBounds,
      strictBounds: true
    }
    self.autocomplete = new google.maps.places.Autocomplete(self.$refs.input, options)
    let place = ''
    self.autocomplete.addListener('place_changed', () => {
      place = self.autocomplete.getPlace()
      if (place.geometry) {
        self.value = place.formatted_address
        let country = ''
        if (place.address_components.some(address => address.types.includes('country'))) {
          const geometry = place.address_components.find(address => address.types.includes('country'))
          if (geometry.short_name === 'CH') {
            country = 'CH'
          }
        }
        self.$emit('placeChanged', { location: place.formatted_address, latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng(), country: country })
      }
    })
    self.selectFirstOnKeydown()
  },
  beforeUpdate () {
    if (!this.focus && this.location !== this.value) {
      this.value = this.location
    }
  }
}
</script>
